export default function LocationSkeleton() {
  return (
    <div className="max-w-[1440px] mx-auto px-[50px] py-[60px] flex flex-col gap-[30px] animate-pulse">
      <div className="h-[40px] lg:h-[50px] w-40 bg-gray-300 rounded-md" /> 
      <div className="w-full h-[498px] bg-gray-200 rounded-[10px]" /> 
    </div>
  )
}
